import {TractorOwnerEndpoints} from "../../common/ProxyEndpoints";
import TTLProxy from "../../common/TTLAsyncProxy";
import {RequestStatus} from "../../common/Constants";

export default class OperatorUtils {

    /**
     * Sum total acres
     * @param requests
     * @param completedOnly
     * @returns {number}
     */
    static sumAcres(requests , completedOnly){

        let acres = 0;
        if(requests) {
            for (let i = 0; i < requests.length; i++) {
                if (completedOnly && requests[i].status == RequestStatus.Completed )
                    acres += requests[i].acres;
            }
        }

        return acres;
    }


    /**
     * Fetches all tractors for the operator
     */
    static fetchOwnerTractors( ownerId, idleOnly , exclude , include){

        const proxy = TTLProxy.getInstance();


        return proxy.processRequest( TractorOwnerEndpoints.getTractors(ownerId).url , {
            method: 'get',
            include: [{
                model: 'operator',
                attributes: ['id','name']
            }]
        } ).then(response => {

            if(response.ok) {

                const _tractors = response.getPayload();

                let tractors =  idleOnly ? _tractors.filter(x => x.operator == null) : _tractors;

                if(exclude)
                    tractors = tractors.filter(x => exclude.indexOf(x.id) < 0);

                if(include){
                    include.forEach(v => {

                        if(tractors.find(x => x.id == v) == null) {

                            let _tv = _tractors.find(x => x.id == v);
                            if(_tv)
                                tractors.unshift(_tv);
                        }

                    });
                }


                return tractors;
            }

            return [];
        });

    }
}


// WEBPACK FOOTER //
// ./src/views/Operators/OperatorUtils.js